export default __webpack_public_path__ + "static/amazonFires7-87eddad913222a456d2d89fc61035b85.gif";